/** @jsx jsx */
import { jsx } from '@emotion/core';
import QRCode, { QRCodeProps } from 'qrcode.react';
import ReactBarcode from 'react-barcode';

import styles from './styles';

// ReactBarcode doesn't have type annotation.
// We can expand this as we need
interface BarcodeProps {
  value: string;
  displayValue?: boolean;
  margin?: number;
  marginLeft?: number;
  marginTop?: number;
  marginRight?: number;
  marginBottom?: number;
}

type PropTypes<T extends string> = (T extends 'qr'
  ? QRCodeProps
  : BarcodeProps) & {
  format: T;
};

const Barcode = <T extends string>(props: PropTypes<T>) => {
  const { format, value } = props;
  return format === 'qr' ? (
    <QRCode value={value} css={{ width: '100%' }} />
  ) : (
    <div css={styles.barcodeContainer}>
      <ReactBarcode {...props} />
    </div>
  );
};

export default Barcode;
